import * as THREE from 'three'
import {useTexture} from '@react-three/drei'

export function useRoomTextures() {
    const roomDayTexture = useTexture('./models/baked_4k90.webp')
    const roomNightTexture = useTexture('./models/baked_night_4k90.webp')
    const booksTexture = useTexture('./models/baked_books_90.webp')

    // TEXTURE SETTINGS
    roomDayTexture.flipY = false
    roomNightTexture.flipY = false
    // roomDayTexture.colorSpace = THREE.SRGBColorSpace
    // roomNightTexture.colorSpace = THREE.SRGBColorSpace

    // roomDayTexture.generateMipmaps = false
    // roomNightTexture.generateMipmaps = false

    // roomDayTexture.magFilter = THREE.NearestFilter
    // roomNightTexture.magFilter = THREE.NearestFilter

    // roomDayTexture.minFilter = THREE.NearestFilter
    // roomNightTexture.minFilter = THREE.NearestFilter

    return {roomDayTexture, roomNightTexture, booksTexture}
}